import React, { useEffect, useRef } from 'react';
import { useChatStore } from '../../../store/chat_store';
import { useAuthStore } from '../../../store/authStore';
import MessageBubble from './MessageBubble';
import TypingIndicator from './TypingIndicator';

const MessageList = () => {
  const { messages, activeConversation, typingStatus } = useChatStore();
  const { user } = useAuthStore();
  const bottomRef = useRef(null);

  useEffect(() => {
    // Auto-scroll to bottom on new messages
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages, typingStatus]);

  if (!activeConversation) return null;
  const isTyping = typingStatus[activeConversation.otherUserId];

  return (
    <div className="flex-1 overflow-y-auto p-4 bg-gray-50/50 flex flex-col space-y-4">
      {messages.length === 0 ? (
        <div className="flex-1 flex items-center justify-center text-gray-400">
          No messages yet. Send a message to start the conversation!
        </div>
      ) : (
        messages.map((msg, idx) => {
          // If msg is populated, sender_id is an object, otherwise it might be a string
          const senderId = msg.sender_id?._id || msg.sender_id;
          const isOwn = String(senderId) === String(user?._id) || String(senderId) === String(user?.id);
          
          return (
            <MessageBubble 
              key={msg._id || idx} 
              message={msg} 
              isOwn={isOwn} 
            />
          );
        })
      )}
      
      {isTyping && (
        <TypingIndicator otherUser={activeConversation.otherUser} />
      )}
      
      <div ref={bottomRef} />
    </div>
  );
};

export default MessageList;
